import { api } from '@/api';

const getAvailableLanguages = () => {
  return api.get('/api/kyc/v1/admin/language');
};
const setLanguage = ({ languageId }) => {
  return api.post('/api/kyc/v1/admin/language', {
    languageId
  });
};
const getAllQuestionnaires = () => {
  return api.get('/api/kyc/v1/admin/questionnaires/all');
};
const getAllQuestionnairesTranslation = (languageId) => {
  return api.get('/api/kyc/v1/admin/questionnaires/all/language', { params: { languageId } });
};
const getQuestionnaireSections = ({ questionSectionTypeId }) => {
  return api.get('/api/kyc/v1/admin/questionnaire/sections', { params: { questionSectionTypeId } });
};
const getQuestionnaireSectionsTranslation = ({ questionSectionTypeId, languageId }) => {
  return api.get('/api/kyc/v1/admin/questionnaire/sections/language', {
    params: {
      questionSectionTypeId,
      languageId
    }
  });
};

const setQuestionnaireInfo = ({ questionSectionTypeId, languageId, name, title, descriptions }) => {
  return api.put('/api/kyc/v1/admin/questionnaires/all', {
    questionSectionTypeId,
    languageId,
    name,
    title,
    descriptions
  });
};
const setQuestionnaireSection = ({
  questionSectionTypeId,
  languageId,
  newText,
  questionSectionId,
  questionGroupId,
  questionId,
  availableAnswerId
}) => {
  return api.put('/api/kyc/v1/admin/questionnaire/sections', {
    questionSectionTypeId,
    languageId,
    newText,
    questionSectionId,
    questionGroupId,
    questionId,
    availableAnswerId
  });
};
const activateQuestionnaireTranslation = ({ questionSectionTypeId, languageId }) => {
  return api.post('/api/kyc/v1/admin/questionnaire/active', {
    questionSectionTypeId,
    languageId
  });
};
const isQuestTranslationActive = ({ questionSectionTypeId, languageId }) =>
  api.get('/api/kyc/v1/admin/questionnaire/active/check', {
    params: {
      questionSectionTypeId,
      languageId
    }
  });
const getAllProducts = () => {
  return api.get('/api/kyc/v1/admin/products/all');
};
const getProductsSections = ({ productId }) => {
  return api.get('/api/kyc/v1/admin/products/sections', { params: { productId } });
};

const getAllScoringCategories = () => {
  return api.get('/api/kyc/v1/admin/scoring/categories');
};

export const adminLocalizationApi = {
  getAvailableLanguages,
  getAllQuestionnaires,
  setQuestionnaireInfo,
  getQuestionnaireSections,
  setQuestionnaireSection,
  activateQuestionnaireTranslation,
  getAllQuestionnairesTranslation,
  getQuestionnaireSectionsTranslation,
  isQuestTranslationActive,
  setLanguage,
  getAllProducts,
  getProductsSections,
  getAllScoringCategories
};

export const adminLocalizationKeys = {
  getAvailableLanguages: 'adminLocalizationApi.getAvailableLanguages',
  getAllQuestionnaires: 'adminLocalizationApi.getAllQuestionnaires',
  getQuestionnaireSections: 'adminLocalizationApi.getQuestionnaireSections',
  getAllQuestionnairesTranslation: 'adminLocalizationApi.getAllQuestionnairesTranslation',
  getQuestionnaireSectionsTranslation: 'adminLocalizationApi.getQuestionnaireSectionsTranslation',
  isQuestTranslationActive: 'adminLocalizationApi.isQuestTranslationActive',
  getAllProducts: 'adminLocalizationApi.getAllProducts',
  getProductsSections: 'adminLocalizationApi.getProductsSections',
  getAllScoringCategories: 'adminLocalizationApi.getAllScoringCategories'
};
